import { render, staticRenderFns } from "./PermissionsRolesForm.vue?vue&type=template&id=c8423376&scoped=true&"
import script from "./PermissionsRolesForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsRolesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8423376",
  null
  
)

export default component.exports